import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    avatar: {
        fontWeight: 700,
        textTransform: 'uppercase',
    },
    atoETheme: {
        backgroundColor: '#D86932',
        color: theme.palette.text.primary,
    },
    fToJTheme: {
        backgroundColor: '#D9A54A',
        color: theme.palette.text.primary,
    },
    kToOTheme: {
        backgroundColor: '#81B5D5',
        color: theme.palette.text.primary,
    },
    pToTTheme: {
        backgroundColor: '#E97CC2',
        color: theme.palette.text.primary,
    },
    defaultTheme: {
        backgroundColor: '#7B9B5F',
        color: theme.palette.text.primary,
    },
}));

const getInitials = (name) => {
    if (!name) return '';
    const parts = name.trim().split(' ').filter(Boolean);
    if (parts.length === 1) return parts[0]?.[0]?.toUpperCase();
    return (
        parts?.[0]?.[0]?.toUpperCase() + parts?.[parts.length - 1]?.[0]?.toUpperCase()
    );
};

const isValidImageSrc = (src) => {
    if (!src) return false;
    try {
        if (src.startsWith('blob:')) return true;
        const url = new URL(src);
        return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (err) {
        return false;
    }
};

const UserAvatar = ({ name = '', src = '', size = 40, className = '', ...rest }) => {
    // ** States
    const [imgError, setImgError] = useState(false);

    // ** Hooks
    const classes = useStyles();

    // ** Helpers
    const getAvatarTheme = (name) => {
        const firstLetter = (name?.[0] || '').toUpperCase();
        if (/[A-E]/.test(firstLetter)) return classes.atoETheme;
        if (/[F-J]/.test(firstLetter)) return classes.fToJTheme;
        if (/[K-O]/.test(firstLetter)) return classes.kToOTheme;
        if (/[P-T]/.test(firstLetter)) return classes.pToTTheme;
        return classes.defaultTheme;
    };

    const initials = getInitials(name);
    const themeClass = getAvatarTheme(name);

    const showInitials = !isValidImageSrc(src) || imgError;

    return (
        <Avatar
            src={showInitials ? undefined : src}
            alt={name || 'User Image'}
            onError={() => setImgError(true)}
            className={`${classes.avatar} ${themeClass} ${className}`}
            style={{
                width: size,
                height: size,
                fontSize: size * 0.35,
            }}
            {...rest}
        >
            {initials}
        </Avatar>
    );
};

export default UserAvatar;
